import { Address, RequireOnly } from '@pelicargo/types';
import { FreightService, Request } from '@prisma/client';
import { useMemo } from 'react';

export type RequestPickupInput = RequireOnly<Request, 'freight_services' | 'cargo_origin'>;

export const getRequestPickupOrigin = (request?: RequestPickupInput): string | undefined => {
  if (!request?.freight_services?.includes(FreightService.EXW)) return undefined;
  const cargoOrigin = request.cargo_origin as Address | null | undefined;
  return cargoOrigin?.zip_code || undefined;
};

export const useRequestPickupOrigin = (request?: RequestPickupInput) =>
  useMemo(() => getRequestPickupOrigin(request), [request?.freight_services, request?.cargo_origin]);
